import { Box } from '@mui/material';
import PageHeader from '../../components/PageHeader/PageHeader';
import { useTranslation } from 'react-i18next';

const Promotions = () => {
  const { t } = useTranslation();

  return (
    <Box p={3}>
      <PageHeader title={t('promotions')} subtitle={t('manage_promotions')} />
      {/* Contenido pendiente de implementación */}
    </Box>
  );
};

export default Promotions;

